var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.027 2.325a4.38 4.38 0 0 1 4.38 4.38v7.566a4.38 4.38 0 0 1-4.38 4.38H6.46a4.38 4.38 0 0 1-4.38-4.38V6.705a4.38 4.38 0 0 1 4.38-4.38h7.566Zm0-1.593H6.46A5.991 5.991 0 0 0 .488 6.705v7.566a5.991 5.991 0 0 0 5.973 5.973h7.566A5.991 5.991 0 0 0 20 14.27V6.705A5.991 5.991 0 0 0 14.027.732Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.448 4.116a1.141 1.141 0 1 0 0 2.283 1.141 1.141 0 0 0 0-2.283ZM10.298 6.997a3.52 3.52 0 1 1 .004 7.041 3.52 3.52 0 0 1-.004-7.04Zm0-1.592a5.113 5.113 0 1 0 .02 10.226 5.113 5.113 0 0 0-.02-10.226Z",
    fill: "#fff"
  })));
};
export default SvgInstagram;